<template>
    <div class="404">
        <Sidebar />
        
        <div class="content-backoffice">
            <div class="content">
                
                <h3 class="title-secondary">{{getMyLanguage("backoffice", "title-error")}}</h3>
                
                <div class="erro404">
                    <img src="~@/assets/images/icons/404.svg" alt="Page not found">
                </div>                    
            </div>
        </div>
    </div>
</template>

<script>
    import Sidebar from '@/components/Sidebar.vue';
    import getMyFavouriteLanguage from "@/services/language.js";


    export default {
        components: {
            Sidebar
        },

        data () {
            return {
                flagSelected: {},
            }
        },
        
        methods: {
            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code
            },
            
            getMyLanguage(group, code){
                return getMyFavouriteLanguage(group, code, this.$store.state.SelectLanguage.code)
            },
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                }
            }
        }
    }
</script>


<style scoped>
    .erro404{display: flex; justify-content: center; width: 100%;}
    .erro404 img{width: 80%; max-width: 400px;}
</style>